export enum ImportAnnotationsStep {
  None,
  Information,
  SelectFile,
  Processing,
  HowToResolveConflicts,
  ResolveConflicts,
  Summary,
}
